import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { MapModule } from '../map/map.module';
import { NavRoutesComponent } from './nav-routes/nav-routes.component';
import { SortableModule } from 'ngx-bootstrap/sortable';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReorderRouteComponent } from './reorder-route/reorder-route.component';
import { DailyRoutesComponent } from './daily-routes/daily-routes.component';
import { ListRoutesComponent } from './list-routes/list-routes.component';

@NgModule({
	declarations: [
		NavRoutesComponent,
		ReorderRouteComponent,
		DailyRoutesComponent,
		ListRoutesComponent
	],
	imports: [
		CommonModule,
		BrowserAnimationsModule,
		FormsModule,
		SharedModule,
		MapModule,
		SortableModule.forRoot()
	]
})
export class RoutesModule {}
